"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const skillsToolRegistry = {
  searchSkills: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./search").then(({ SearchSkillsToolView }) => ({
        default: SearchSkillsToolView,
      }))
    ),
  },
  displaySkill: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./display-skill").then(({ DisplaySkillToolView }) => ({
        default: DisplaySkillToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
